<template>
  <div class="cancel-subscription-page">
    <h1>Are you sure you want to cancel your subscription?</h1>
    <alert class="alert" v-if="error">
      {{ error }}
    </alert>
    <cta-button
      type="button"
      class="button"
      :loading="isLoading"
      @click="cancelSubscription()"
      >Cancel subscription</cta-button
    >
    <cta-button
      type="button"
      class="button"
      :disabled="isLoading"
      @click="navToSubscriptionPage()"
      >Keep my subscription</cta-button
    >
  </div>
</template>

<script>
import Alert from "@/components/Alert";
import CtaButton from "@/components/CtaButton";

export default {
  name: "CancelSubscriptionPage",
  components: {
    CtaButton,
    Alert,
  },
  data() {
    return {
      isLoading: false,
      error: null,
    };
  },
  methods: {
    cancelSubscription() {
      this.error = null;
      this.isLoading = true;
      this.$user
        .cancelSubscription()
        .then(this.$tracker.trackCancel.bind(this.$tracker))
        .then(this.$user.getProfile.bind(this.$user))
        .then(this.subscriptionCanceled)
        .catch(this.handleSubscriptionCancelError);
    },
    subscriptionCanceled() {
      this.isLoading = false;
      this.$router.push({ name: "cancelConfirmation" });
    },
    handleSubscriptionCancelError() {
      this.error =
        "Something went wrong canceling your subscription. Please try again.";
      this.isLoading = false;
    },
    navToSubscriptionPage() {
      this.$router.push({ name: "subscription" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variables";
@import "@/style/mixins";

.cancel-subscription-page {
}
</style>
